import { APIService } from "../../../../network/api/APIService";


export const ForgotPasswordCALL = (formData) => {
  return APIService({
      endpoint: "/authentication/forgot-password/",
      method: "POST",
      data: formData
  });
};